import { LoaderFunction, useFetcher } from "react-router-dom";
import { getExpiredAssets } from "../../../common/api/decimal/methods/license.ts";

export const expiredLoader: LoaderFunction = async ({ params }) => {
  if (params.page) {
    return getExpiredAssets(parseInt(params.page, 10));
  }
};

export function useExpiredFetcher() {
  return useFetcher<Awaited<ReturnType<typeof getExpiredAssets>>>();
}
